import React from 'react';

interface SpotifyLogoProps {
  size?: number;
  title?: string;
}

// Logo simplificado do Spotify (círculo verde + 3 ondas)
export const SpotifyLogo: React.FC<SpotifyLogoProps> = ({ size = 32, title = 'Spotify' }) => {
  const radius = size / 2;
  const stroke = Math.max(2, Math.floor(size * 0.08));
  const center = radius;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <circle cx={center} cy={center} r={radius} fill="#1DB954" />
      {/* Ondas (arcos) - cor escura para bom contraste */}
      <path
        d={`M ${size*0.22} ${size*0.62} C ${size*0.45} ${size*0.50}, ${size*0.75} ${size*0.55}, ${size*0.80} ${size*0.70}`}
        fill="none"
        stroke="#121212"
        strokeWidth={stroke}
        strokeLinecap="round"
        opacity="0.9"
      />
      <path
        d={`M ${size*0.26} ${size*0.73} C ${size*0.48} ${size*0.66}, ${size*0.70} ${size*0.68}, ${size*0.76} ${size*0.79}`}
        fill="none"
        stroke="#121212"
        strokeWidth={stroke}
        strokeLinecap="round"
        opacity="0.9"
      />
      <path
        d={`M ${size*0.30} ${size*0.83} C ${size*0.48} ${size*0.79}, ${size*0.64} ${size*0.79}, ${size*0.72} ${size*0.87}`}
        fill="none"
        stroke="#121212"
        strokeWidth={stroke}
        strokeLinecap="round"
        opacity="0.9"
      />
    </svg>
  );
};

